<section class="row primary-footer gy-7">
  <div
    *ngFor="let content of nestedFirstColumn"
    class="col-xl-2 title-container"
  >
    <digital-platform-dynamic-content-wrapper
      [config]="content"
    ></digital-platform-dynamic-content-wrapper>
  </div>
  <div class="col-xl-4 subscribe-col">
    <div
      *ngFor="let content of nestedSecondColumn"
      [ngClass]="{
        'd-inline-block': content.type === 'inlineImage',
        'custom-inline-img-container': content.type === 'inlineImage',
        'd-block': content.type !== 'inlineImage',
        'fw-bold': content.type === 'richText'
      }"
    >
      <digital-platform-dynamic-content-wrapper [config]="content">
      </digital-platform-dynamic-content-wrapper>
    </div>
  </div>
</section>
